import { CartLinesUpdateEvent } from '@shopify/events';

// Offer forms added through Custom Liquid use a plain Shopify product form.
// Give those forms the same AJAX cart flow as the theme's product-form component.
document.addEventListener('submit', async (event) => {
  if (event.defaultPrevented || !window.location.pathname.startsWith('/products/')) return;

  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  if (!form.action.includes('/cart/add') || form.closest('product-form-component')) return;

  const formData = new FormData(form);
  const variantId = formData.get('id');
  if (!variantId) return;

  event.preventDefault();
  if (form.dataset.cartSubmitting === 'true') return;
  form.dataset.cartSubmitting = 'true';

  const submitButton = event.submitter instanceof HTMLButtonElement ? event.submitter : form.querySelector('[type="submit"]');
  if (submitButton) submitButton.disabled = true;

  const sectionIds = [...new Set(
    [...document.querySelectorAll('cart-items-component[data-section-id]')]
      .map((element) => element.dataset.sectionId)
      .filter(Boolean)
  )];
  if (sectionIds.length) formData.set('sections', sectionIds.join(','));

  const update = CartLinesUpdateEvent.createPromise();
  form.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add',
    context: 'product',
    lines: [{ merchandiseId: String(variantId), quantity: Number(formData.get('quantity')) || 1 }],
    promise: update.promise,
  }));

  try {
    const addResponse = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: formData,
    });
    const added = await addResponse.json();
    if (!addResponse.ok || added.status) throw new Error(added.description || added.message || 'Impossible d’ajouter ce produit.');

    const cartResponse = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
    if (!cartResponse.ok) throw new Error('Impossible de mettre à jour le panier.');
    const cart = await cartResponse.json();

    update.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        sections: added.sections,
        source: 'cocoom-native-product-form',
        itemCount: Number(formData.get('quantity')) || 1,
        didError: false,
      },
    });
  } catch (error) {
    update.reject(error);
    let message = form.querySelector('.cocoom-cart-add-error');
    if (!message) {
      message = document.createElement('p');
      message.className = 'cocoom-cart-add-error';
      message.setAttribute('role', 'alert');
      message.style.cssText = 'color:#a21d31;font-size:14px;margin:8px 0 0';
      form.append(message);
    }
    message.textContent = error.message || 'Impossible d’ajouter ce produit.';
  } finally {
    delete form.dataset.cartSubmitting;
    if (submitButton) submitButton.disabled = false;
  }
});
